"use strict";

exports.__esModule = true;
exports.resolveQuestionResponses = exports.createSurveyResponseExportData = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("../../utils/constants");

var _conditions = require("./conditions");

var _defaultValues = require("./defaultValues");

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var getResponseDataModelForQuestion = function getResponseDataModelForQuestion(id, component, questions, instances, totalInstances) {
  var parsedInstances = instances.map(function (i) {
    return Object.assign({}, i, {
      questionResponse: {
        value: i.response && i.response.payload && i.response.payload.filter(function (p) {
          return p.questionId === id;
        })[0] ? i.response.payload.filter(function (p) {
          return p.questionId === id;
        })[0].value : null,
        user: {
          name: i.response.userName,
          email: i.response.userEmail
        },
        dateTime: i.response.dateTime
      }
    });
  });
  var validResponses = parsedInstances.filter(function (i) {
    return i.questionResponse.value !== (0, _defaultValues.getDefaultQuestionResponse)(component.type);
  });
  var linkedConditions = (0, _conditions.getLinkedQuestionConditions)(questions, id);
  var responseModel = {
    responseValues: null,
    responses: validResponses,
    totalInstances: totalInstances.length,
    totalResponses: validResponses.length
  };

  switch (component.type) {
    case _constants.CHOICE_TYPE:
      {
        var choices = component.props.choices;
        return Object.assign({}, responseModel, {
          responseValues: choices.map(function (c) {
            return {
              id: c.id,
              value: c.value,
              responses: validResponses.filter(function (i) {
                return i.questionResponse.value.includes(c.id);
              }),
              linkedCondition: linkedConditions ? linkedConditions.filter(function (x) {
                return x.value === c.id;
              }).map(function (y) {
                return y.question;
              })[0] : null,
              total: validResponses.filter(function (i) {
                return i.questionResponse.value.includes(c.id);
              }).length
            };
          })
        });
      }

    case _constants.RATING_TYPE:
      {
        var ratingOptions = component.props.ratingOptions;
        return Object.assign({}, responseModel, {
          responseValues: Array.from(Array(ratingOptions).keys()).map(function (r, i) {
            return {
              value: i + 1,
              responses: validResponses.filter(function (r) {
                return r.questionResponse.value === i + 1;
              }),
              linkedCondition: linkedConditions ? linkedConditions.filter(function (x) {
                return x.value === i + 1;
              }).map(function (y) {
                return y.question;
              })[0] : null,
              total: validResponses.filter(function (r) {
                return r.questionResponse.value === i + 1;
              }).length
            };
          })
        });
      }

    case _constants.ADDRESS_CHECKER_TYPE:
    case _constants.FILE_UPLOAD_TYPE:
    case _constants.TEXT_ANSWER_TYPE:
    default:
      return responseModel;
  }
};

var resolveQuestionResponses = function resolveQuestionResponses(
/** The questions that have been asked as part of the content of the activity */
questions,
/** The instances linked to the activity */
instances) {
  var respondedInstances = instances.length === 0 ? [] : instances.filter(function (i) {
    return i.response !== null;
  }).map(function (i) {
    return Object.assign({}, i, {
      response: JSON.parse(i.response)
    });
  });
  var questionsWithResponses = questions.map(function (q) {
    return Object.assign({}, q, getResponseDataModelForQuestion(q.id, q.component, questions, respondedInstances, instances));
  });
  console.log({
    questions: questionsWithResponses,
    totalInstances: instances.length,
    totalResponses: respondedInstances.length
  });
  return {
    questions: questionsWithResponses,
    totalInstances: instances.length,
    totalResponses: respondedInstances.length
  };
};

exports.resolveQuestionResponses = resolveQuestionResponses;
resolveQuestionResponses.PropTypes = {
  questions: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string,
    position: _propTypes.default.number,
    title: _propTypes.default.string,
    description: _propTypes.default.description,
    conditions: _propTypes.default.arrayOf(_propTypes.default.shape({
      questionId: _propTypes.default.string,
      value: _propTypes.default.any
    })),
    component: _propTypes.default.shape({
      type: _propTypes.default.string,
      props: _propTypes.default.object
    })
  })).isRequired,
  instances: _propTypes.default.arrayOf(_propTypes.default.shape({
    templateId: _propTypes.default.number,
    assignmentId: _propTypes.default.number,
    instanceId: _propTypes.default.number,
    referenceId: _propTypes.default.string,
    storeCode: _propTypes.default.string,
    visibleFromDate: _propTypes.default.string,
    activeFromDate: _propTypes.default.string,
    dueDate: _propTypes.default.string,
    viewedOn: _propTypes.default.string,
    viewedByName: _propTypes.default.string,
    markedInProgressOn: _propTypes.default.string,
    markedInProgressByName: _propTypes.default.string,
    completedOn: _propTypes.default.string,
    completedByName: _propTypes.default.string,
    deletedOn: _propTypes.default.string,
    response: _propTypes.default.string
  })).isRequired
};

var resolveQuestionResponse = function resolveQuestionResponse(question, response) {
  if (response === void 0) {
    response = null;
  }

  if (response === null) return '';

  switch (question.component.type) {
    case _constants.CHOICE_TYPE:
      return JSON.stringify(response.map(function (x) {
        return question.component.props.choices.map(function (c) {
          return c.id;
        }).includes(x) ? question.component.props.choices.filter(function (c) {
          return c.id === x;
        })[0].value : x;
      }));

    default:
      return JSON.stringify(response);
  }
};

var fileModel = {
  columns: [],
  rows: [],
  fileName: ''
};

var createSurveyResponseExportData = function createSurveyResponseExportData(questions, instances) {
  var _file$columns;

  var file = fileModel;
  file.fileName = instances[0].templateId + "_Responses_" + (0, _moment.default)().format('DDMMyyyyHHmmss');
  var rows = [];
  var questionList = [];
  var questionCount = 0;
  Array.from(questions).forEach(function (question) {
    questionCount++;
    questionList.push("Q" + questionCount + " - " + question.title);
  });
  file.columns = _constants.SURVEY_EXPORT_FILE_COLUMNS;

  (_file$columns = file.columns).push.apply(_file$columns, questionList);

  instances.forEach(function (instance) {
    var questionResponseList = [];
    var response = JSON.parse(instance.response);
    questions.forEach(function (question) {
      questionResponseList.push(resolveQuestionResponse(question, response && response.payload && response.payload.filter(function (res) {
        return res.questionId === question.id;
      })[0] ? response.payload.filter(function (res) {
        return res.questionId === question.id;
      })[0].value : null));
    });
    rows.push([instance.storeCode, instance.viewedOn, instance.viewedByName, instance.completedOn, instance.completedByName].concat(questionResponseList));
  });
  file.rows = rows;
  return file;
};

exports.createSurveyResponseExportData = createSurveyResponseExportData;
createSurveyResponseExportData.PropTypes = {
  questions: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string,
    position: _propTypes.default.number,
    title: _propTypes.default.string,
    description: _propTypes.default.description,
    conditions: _propTypes.default.arrayOf(_propTypes.default.shape({
      questionId: _propTypes.default.string,
      value: _propTypes.default.any
    })),
    component: _propTypes.default.shape({
      type: _propTypes.default.string,
      props: _propTypes.default.object
    })
  })).isRequired,
  instances: _propTypes.default.arrayOf(_propTypes.default.shape({
    templateId: _propTypes.default.number,
    assignmentId: _propTypes.default.number,
    instanceId: _propTypes.default.number,
    referenceId: _propTypes.default.string,
    storeCode: _propTypes.default.string,
    visibleFromDate: _propTypes.default.string,
    activeFromDate: _propTypes.default.string,
    dueDate: _propTypes.default.string,
    viewedOn: _propTypes.default.string,
    viewedByName: _propTypes.default.string,
    markedInProgressOn: _propTypes.default.string,
    markedInProgressByName: _propTypes.default.string,
    completedOn: _propTypes.default.string,
    completedByName: _propTypes.default.string,
    deletedOn: _propTypes.default.string,
    response: _propTypes.default.string
  })).isRequired
};